import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../services/firebase';

const ProposedDetails = ({ groupId }) => {
  const [isEditingTime, setIsEditingTime] = useState(false);
  const [isEditingPlace, setIsEditingPlace] = useState(false);
  const [proposedTime, setProposedTime] = useState(null);
  const [proposedPlace, setProposedPlace] = useState('');

  // Fetch data from Firebase
  useEffect(() => {
    const fetchData = async () => {
      const groupRef = doc(db, 'groups', groupId);
      const groupSnap = await getDoc(groupRef);

      if (!groupSnap.exists()) {
        console.warn('Group not found for groupId:', groupId);
        return;
      }

      const data = groupSnap.data();

      // Check if proposedTime exists
      if (data.proposedTime) {
        setProposedTime(new Date(data.proposedTime.seconds * 1000));
      } else if (data.commonAvailability?.dateFrom && data.commonAvailability?.hourFrom) {
        // Combine dateFrom and hourFrom into a single Date object
        const combinedDateTime = new Date(`${data.commonAvailability.dateFrom}T${data.commonAvailability.hourFrom}:00`);
        setProposedTime(combinedDateTime);
      } else {
        // Fallback to current date
        setProposedTime(new Date());
      }

      setProposedPlace(data.proposedPlace || '');
    };

    fetchData();
  }, [groupId]);

  // Save time to Firebase
  const saveTime = async () => {
    const groupRef = doc(db, 'groups', groupId);
    await updateDoc(groupRef, {
      proposedTime: proposedTime,
    });
    setIsEditingTime(false);
  };

  // Save place to Firebase
  const savePlace = async () => {
    const groupRef = doc(db, 'groups', groupId);
    await updateDoc(groupRef, {
      proposedPlace: proposedPlace,
    });
    setIsEditingPlace(false);
  };

  return (
    <div className="bg-light border-bottom py-2">
      <div className="container-fluid">
        <div className="row row-cols-1 row-cols-md-2 g-2">
          {/* Proposed Time */}
          <div className="col d-flex align-items-center">
            <span className="fw-semibold me-2 small">Proposed Time:</span>
            {isEditingTime ? (
              <DatePicker
                selected={proposedTime}
                onChange={(date) => setProposedTime(date)}
                showTimeSelect
                dateFormat="Pp"
                className="form-control form-control-sm me-3"
              />
            ) : (
              <span className="text-body-secondary me-3 small">
                {proposedTime?.toLocaleString('en-US', {
                  dateStyle: 'medium',
                  timeStyle: 'short',
                })}
              </span>
            )}
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => (isEditingTime ? saveTime() : setIsEditingTime(true))}
            >
              {isEditingTime ? 'Save' : 'Edit'}
            </button>
          </div>

          {/* Proposed Place */}
          <div className="col d-flex align-items-center">
            <span className="fw-semibold me-2 small">Proposed Place:</span>
            {isEditingPlace ? (
              <input
                type="text"
                value={proposedPlace}
                onChange={(e) => setProposedPlace(e.target.value)}
                className="form-control form-control-sm me-3"
              />
            ) : (
              <span className="text-body-secondary me-3 small">{proposedPlace}</span>
            )}
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => (isEditingPlace ? savePlace() : setIsEditingPlace(true))}
            >
              {isEditingPlace ? 'Save' : 'Edit'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProposedDetails;
